module.exports = __webpack_public_path__ + "img/training-strength.a1d0256e.svg";